import React, { useState, useRef, useEffect } from "react";
import { Calendar, Search, ChevronDown, ChevronUp } from "lucide-react";
import DatePicker from "react-datepicker";
import {
  handleAphabetsChange,
  check_vaild_save,
  combiled_form_data,
  handleSuccessSession,
  handleSuccessShow,
  handleError,
} from "../../CommonJquery/CommonJquery.js";

import {
  server_post_data,
  payment_reallocation,
} from "../../ServiceConnection/serviceconnection.js";
import DummyDriver from "../../assets/dummyDriver.jpeg";
import Loader from "../Loader.js";

const PaymentHeadsSettlement = ({
  activeSection,
  paymentHeadsSettlement,
  setPaymentHeadsSettlement,
  driverData,
  imageLink,
  master_data_getDriverData,
  master_data_get,
  selectedDriverId,
  selectedDriverBookingId,
  startDateAll,
  endDateAll,
  dateRangeType,
}) => {
  const [startDate, setStartDate] = useState(new Date());
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [isDriverDropdownOpen, setIsDriverDropdownOpen] = useState(false);
  const [driverSearchQuery, setDriverSearchQuery] = useState("");
  const [bookingType, setbookingType] = useState("1");
  const [paymentMode, setpaymentMode] = useState("");
  const [ledger_data, set_ledger_data] = useState("");
  const [rent, setrent] = useState(0);
  const [rentSettleto, setrentSettleto] = useState("");
  const [tolls, settolls] = useState(0);
  const [tollsSettleto, settollsSettleto] = useState("");
  const [damage, setdamage] = useState(0);
  const [damageSettleto, setdamageSettleto] = useState("");
  const [ticket, setticket] = useState(0);
  const [ticketSettleto, setticketSettleto] = useState("");
  const [letfees, setletfees] = useState(0);
  const [letfeesSettleto, setletfeesSettleto] = useState("");
  const [letotherchr, setotherchr] = useState(0);
  const [letotherchrSettleto, setotherchrSettleto] = useState("");

  // Checkbox states for each head
  const [rentChecked, setRentChecked] = useState(false);
  const [tollsChecked, setTollsChecked] = useState(false);
  const [damageChecked, setDamageChecked] = useState(false);
  const [ticketChecked, setTicketChecked] = useState(false);
  const [letfeesChecked, setLetfeesChecked] = useState(false);
  const [letotherchrChecked, setLetotherchrChecked] = useState(false);

  // const [deposit, setdeposit] = useState('')
  const [discount, setdiscount] = useState("");
  const [notes, setnotes] = useState("");
  const [totalamount, settotalamount] = useState("");
  const driverDropdownRef = useRef(null);

  const [error, setError] = useState("");

  const capitalizeWords = (str) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  useEffect(() => {
    const rentValue = rentChecked ? parseInt(rent) || 0 : 0;
    const tollsValue = tollsChecked ? parseInt(tolls) || 0 : 0;
    const damageValue = damageChecked ? parseInt(damage) || 0 : 0;
    const ticketValue = ticketChecked ? parseInt(ticket) || 0 : 0;
    const letfeesValue = letfeesChecked ? parseInt(letfees) || 0 : 0;
    const letotherchrValue = letotherchrChecked
      ? parseInt(letotherchr) || 0
      : 0;

    // console.log(rent, tolls, damage, ticket, letfees, letotherchr);
    // console.log(selectedDriver?.booking_data);

    settotalamount(
      rentValue +
        tollsValue +
        damageValue +
        ticketValue +
        letfeesValue +
        letotherchrValue
    );
  }, [
    rent,
    tolls,
    damage,
    ticket,
    letfees,
    letotherchr,
    rentChecked,
    tollsChecked,
    damageChecked,
    ticketChecked,
    letfeesChecked,
    letotherchrChecked,
  ]);

  // Add click outside listener to close dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        driverDropdownRef.current &&
        !driverDropdownRef.current.contains(event.target)
      ) {
        setIsDriverDropdownOpen(false);
      }
    }

    // Add event listener if dropdown is open
    if (isDriverDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Cleanup the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDriverDropdownOpen]);

  // Function to handle checkbox changes
  const handleCheckboxChange = (headType, isChecked) => {
    switch (headType) {
      case "rent":
        setRentChecked(isChecked);
        if (!isChecked) {
          setrent(0);
          setrentSettleto("");
        }
        break;
      case "tolls":
        setTollsChecked(isChecked);
        if (!isChecked) {
          settolls(0);
          settollsSettleto("");
        }
        break;
      case "damage":
        setDamageChecked(isChecked);
        if (!isChecked) {
          setdamage(0);
          setdamageSettleto("");
        }
        break;
      case "ticket":
        setTicketChecked(isChecked);
        if (!isChecked) {
          setticket(0);
          setticketSettleto("");
        }
        break;
      case "letfees":
        setLetfeesChecked(isChecked);
        if (!isChecked) {
          setletfees(0);
          setletfeesSettleto("");
        }
        break;
      case "letotherchr":
        setLetotherchrChecked(isChecked);
        if (!isChecked) {
          setotherchr(0);
          setotherchrSettleto("");
        }
        break;
      default:
        break;
    }
  };

  // Add this function before your handleSaveChangesdynamic function
  const createFormDataArrays = () => {
    const heads = [];
    const settle_to = [];
    const settle_amount = [];

    // Check each head and add to arrays if checked and has values
    if (rentChecked && rent > 0 && rentSettleto) {
      heads.push("rent");
      settle_to.push(rentSettleto);
      settle_amount.push(rent.toString());
    }

    if (tollsChecked && tolls > 0 && tollsSettleto) {
      heads.push("tolls");
      settle_to.push(tollsSettleto);
      settle_amount.push(tolls.toString());
    }

    if (damageChecked && damage > 0 && damageSettleto) {
      heads.push("damage");
      settle_to.push(damageSettleto);
      settle_amount.push(damage.toString());
    }

    if (ticketChecked && ticket > 0 && ticketSettleto) {
      heads.push("ticket");
      settle_to.push(ticketSettleto);
      settle_amount.push(ticket.toString());
    }

    if (letfeesChecked && letfees > 0 && letfeesSettleto) {
      heads.push("letfees");
      settle_to.push(letfeesSettleto);
      settle_amount.push(letfees.toString());
    }

    if (letotherchrChecked && letotherchr > 0 && letotherchrSettleto) {
      heads.push("letotherchr");
      settle_to.push(letotherchrSettleto);
      settle_amount.push(letotherchr.toString());
    }

    return { heads, settle_to, settle_amount };
  };

  const handleCreateArray = () => {
    const { heads, settle_to, settle_amount } = createFormDataArrays();
    //console.log("Heads array:", heads);
    //console.log("Settle to array:", settle_to);
    //console.log("Settle amount array:", settle_amount);
  };

  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    let vaild_data = check_vaild_save(form_data);
    // Create the arrays
    const { heads, settle_to, settle_amount } = createFormDataArrays();
    if (vaild_data) {
      const totalAmtText = document.querySelector(".totlamt").textContent;
      const totalAmt = parseFloat(totalAmtText.replace(/[^0-9.-]/g, ""));
      if (totalamount <= 0) {
        alert("Total amount must be greater than zero.");
        return;
      }
      if (selectedDriver == null) {
        alert("Please select a Driver");
        return;
      }

      // if (!bookingType) {
      //   alert("Please Select Booking Type");
      //   return;
      // }

      setshowLoaderAdmin(true);
      let fd_from = combiled_form_data(form_data, null);
      // fd_from.append("booking_id", selectedDriver?.booking_data?.primary_id);
      if (bookingType == "1") {
        fd_from.append("booking_id", selectedDriver?.booking_data?.primary_id);
      }
      if (bookingType == "2") {
        fd_from.append(
          "booking_id",
          selectedDriver?.old_booking_data?.primary_id
        );
      }
      fd_from.append("payment_date", formatDate(startDate));
      fd_from.append("heads", heads);
      fd_from.append("settle_to", settle_to);
      fd_from.append("settle_amount", settle_amount);
      // fd_from.append("payment_mode", paymentMode);
      fd_from.append("booking_type", bookingType);
      await server_post_data(url_for_save, fd_from)
        .then((Response) => {
          setshowLoaderAdmin(false);
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            // handleSuccessSession(Response.data.message);
            setPaymentHeadsSettlement(true);
            handleSuccessShow("Successfully Saved!");
            master_data_getDriverData(); // Call function again to refresh data
            master_data_get(
              startDateAll,
              endDateAll,
              2,
              dateRangeType,
              selectedDriverId,
              selectedDriverBookingId
            );
            setDriverSearchQuery("");
            setrent(0);
            setrentSettleto("");
            settolls(0);
            settollsSettleto("");
            setdamage(0);
            setdamageSettleto("");
            setticket(0);
            setticketSettleto("");
            setletfees(0);
            setletfeesSettleto("");
            setotherchr(0);
            setotherchrSettleto("");
            setRentChecked(false);
            setTollsChecked(false);
            setDamageChecked(false);
            setTicketChecked(false);
            setLetfeesChecked(false);
            setLetotherchrChecked(false);
            settotalamount(0);
            setSelectedDriver(null);
          }
        })
        .catch((error) => {
          setshowLoaderAdmin(false);
          handleError("network");
        });
    }
  };
  function formatDate(dateObj) {
    const year = dateObj.getFullYear();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObj.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  const handleSelectDriver = (driver) => {
    setSelectedDriver(driver);
    setIsDriverDropdownOpen(false);
    setDriverSearchQuery("");
    // console.log(driver);
    // You can add additional logic here to load transactions for the selected driver
    setrent(0);
    setrentSettleto("");
    settolls(0);
    settollsSettleto("");
    setdamage(0);
    setdamageSettleto("");
    setticket(0);
    setticketSettleto("");
    setletfees(0);
    setletfeesSettleto("");
    setotherchr(0);
    setotherchrSettleto("");
    setRentChecked(false);
    setTollsChecked(false);
    setDamageChecked(false);
    setTicketChecked(false);
    setLetfeesChecked(false);
    setLetotherchrChecked(false);
  };

  // Fix: Only search by name and ID (which exists in the driver objects)
  const filteredDrivers = driverData
    ? driverData.filter(
        (driver) =>
          (driver.name ? driver.name.toLowerCase() : "").includes(
            driverSearchQuery.toLowerCase()
          ) ||
          (driver.primary_id
            ? driver.primary_id.toString().toLowerCase()
            : ""
          ).includes(driverSearchQuery.toLowerCase())
      )
    : [];

  return (
    <>
      {showLoaderAdmin && <Loader />}
      <section
        id="payment-entry"
        className={`accounting-section ${
          activeSection === "transaction-edit" ? "" : "accounting-hidden"
        }`}
      >
        {/* <div className="accounting-section-header">
          <h2 className="accounting-section-title">Payment Adjustment</h2>
          <div className="accounting-header-actions"></div>
        </div> */}

        <div className="accounting-payment-form">
          <div className="accounting-payment-header">
            <div className="accounting-payment-fields">
              <div
                className="accounting-filter-group"
                style={{ paddingTop: "2px" }}
              >
                <label htmlFor="start-date" className="accounting-label">
                  Date
                </label>
                <div className="accounting-date-input-wrapper">
                  <DatePicker
                    id="start-date"
                    name="start-date"
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    className="accounting-date-input borderRadiusnew mt-0"
                    placeholderText="MM/DD/YYYY"
                    dateFormat="MM/dd/yyyy"
                    maxDate={new Date()}
                    readOnly
                  />
                  <Calendar className="accounting-date-icon" size={18} />
                </div>
              </div>

              {/* <div className="accounting-payment-field">
                <label htmlFor="payment-mode" className="accounting-label">
                  Booking Type
                </label>
                <select
                  id="payment-mode"
                  name="payment-mode"
                  className="accounting-select"
                  value={bookingType}
                  onChange={(e) => setbookingType(e.target.value)}
                >
                  <option value="" disabled hidden>
                    Select Booking Type
                  </option>
                  <option value="1">Active</option>
                  <option value="2">Dropped</option>
                </select>
              </div> */}

              <div className="accounting-payment-field">
                <label htmlFor="select-driver" className="accounting-label">
                  Select Driver
                </label>
                <div className="position-relative" ref={driverDropdownRef}>
                  <div
                    className="form-floating form-control shadow-sm d-flex justify-content-between align-items-center cursor-pointer"
                    onClick={() =>
                      setIsDriverDropdownOpen(!isDriverDropdownOpen)
                    }
                    style={{
                      cursor: "pointer",
                      height: "40px",
                      paddingTop: "10px",
                      marginTop: "6px",
                    }}
                  >
                    {selectedDriver ? (
                      <div className="fw-medium">{selectedDriver.name}</div>
                    ) : (
                      <div className="">Choose a driver</div>
                    )}
                    <div
                      className="position-absolute"
                      style={{
                        bottom: "6px",
                        right: "10px",
                        pointerEvents: "none",
                      }}
                    >
                      {isDriverDropdownOpen ? (
                        <ChevronUp size={16} />
                      ) : (
                        <ChevronDown size={16} />
                      )}
                    </div>
                  </div>

                  {isDriverDropdownOpen && (
                    <div
                      className="position-absolute w-100 bg-white shadow-lg rounded-bottom z-index-1000"
                      style={{ zIndex: 1000 }}
                    >
                      <div className="p-2 border-bottom">
                        <div className="input-group">
                          <span
                            className="input-group-text bg-white border-end-0"
                            style={{ marginTop: "5px" }}
                          >
                            <Search size={16} />
                          </span>
                          <input
                            type="text"
                            className="form-control border-start-0"
                            placeholder="Search by name or ID..."
                            value={driverSearchQuery}
                            onChange={(e) =>
                              setDriverSearchQuery(e.target.value)
                            }
                            autoFocus
                          />
                        </div>
                      </div>
                      <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                        {filteredDrivers.length > 0 ? (
                          filteredDrivers.map((driver) => (
                            <div
                              key={driver.primary_id}
                              className="p-2 border-bottom hover-bg-light cursor-pointer"
                              // onClick={() => handleSelectDriver(driver)}
                              onClick={() => {
                                const booking = driver?.booking_data;
                                console.log("mk", booking);

                                if (!booking) {
                                  alert("This driver has no booking.");
                                  setSelectedDriver(null);
                                  return;
                                }

                                const step = booking.step_for_booking;
                                const switchType = booking.payment_cycle_switch;

                                if (
                                  step === "5" &&
                                  ["1", "2", "3"].includes(switchType)
                                ) {
                                  alert(
                                    "This driver has no active booking. The last booking was a switched booking."
                                  );
                                  setSelectedDriver(null);
                                  return;
                                }

                                if (step === "6") {
                                  alert(
                                    "Please complete the last booking switch process before continuing."
                                  );
                                  setSelectedDriver(null);
                                  return;
                                }

                                if (step === "7") {
                                  alert(
                                    "Please complete the last booking repo process before continuing."
                                  );
                                  setSelectedDriver(null);
                                  return;
                                }

                                if (["0", "1", "2", "3"].includes(step)) {
                                  alert(
                                    "This driver has a booking in progress but it is not active yet."
                                  );
                                  setSelectedDriver(null);
                                  return;
                                }

                                if (["9", "10"].includes(step)) {
                                  alert(
                                    "The last booking was either rejected or canceled."
                                  );
                                  setSelectedDriver(null);
                                  return;
                                }

                                handleSelectDriver(driver);
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <div className="fw-medium">{driver.name}</div>
                              <div className="small text-muted">
                                ID: {driver.primary_id}
                                {/* - Outstanding:{" "}
                              {driver.outstanding} */}
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="p-3 text-center text-muted">
                            No drivers found
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {selectedDriver != null && (
              <div className="accounting-driver-profile">
                <div className="accounting-driver-avatar-container">
                  <img
                    // src={
                    //   selectedDriver.user_image &&
                    //     selectedDriver.user_image.trim() !== "" &&
                    //     selectedDriver.user_image.trim().toLowerCase() !==
                    //     "null"
                    //     ? imageLink + selectedDriver.user_image
                    //     : "https://avatar.iran.liara.run/public/36"
                    // }
                    src={DummyDriver}
                    alt="Driver Photo"
                    className="accounting-driver-avatar-large"
                  />
                </div>
                <div>
                  <h3 className="accounting-driver-name-large">
                    {selectedDriver.name}{" "}
                    {selectedDriver?.old_booking_data?.payment_cycle_switch ==
                      "1" && <span className="newTagPAy">I-Pass Switched</span>}
                    {selectedDriver?.old_booking_data?.payment_cycle_switch ==
                      "2" && <span className="newTagPAy">Car Switched</span>}
                  </h3>
                  <p className="accounting-driver-details m-0">
                    Outstanding: $
                    {bookingType == "1"
                      ? selectedDriver?.booking_data?.total_due ?? 0
                      : selectedDriver?.old_booking_data?.total_due ?? 0}
                  </p>
                </div>
              </div>
            )}
          </div>
          <form className="createRightsForm" id="createRightsForm">
            <div className="accounting-services-due">
              <div className="accounting-services-header p-0">
                <div
                  className="accounting-service-item"
                  style={{ borderBottom: "0" }}
                >
                  <div className="accounting-service-info">
                    <div className="accounting-service-checkbox">
                      <label
                        htmlFor="rent_amount"
                        className="accounting-service-label"
                      >
                        <span
                          className="accounting-service-name"
                          style={{ width: "165px" }}
                        >
                          Heads
                        </span>
                      </label>
                    </div>
                  </div>

                  <div className="accounting-service-amount">
                    <label
                      htmlFor="rent_amount"
                      className="accounting-service-label"
                    >
                      <span
                        className="accounting-service-name"
                        style={{ width: "60px" }}
                      >
                        Due
                      </span>
                    </label>
                  </div>

                  <div className="accounting-service-amount">
                    <label
                      htmlFor="rent_amount"
                      className="accounting-service-label"
                    >
                      <span
                        className="accounting-service-name"
                        style={{ width: "60px" }}
                      >
                        Paid
                      </span>
                    </label>
                  </div>

                  <div className="accounting-service-amount">
                    <label
                      htmlFor="rent_amount"
                      className="accounting-service-label"
                    >
                      <span
                        className="accounting-service-name"
                        style={{ width: "102px" }}
                      >
                        Settle To
                      </span>
                    </label>
                  </div>

                  <div className="accounting-service-amount">
                    <label
                      htmlFor="rent_amount"
                      className="accounting-service-label"
                    >
                      <span
                        className="accounting-service-name"
                        style={{ width: "100px" }}
                      >
                        Head Due
                      </span>
                    </label>
                  </div>

                  <div className="accounting-service-amount">
                    <label
                      htmlFor="rent_amount"
                      className="accounting-service-label"
                    >
                      <span
                        className="accounting-service-name"
                        style={{ width: "102px" }}
                      >
                        Settle Amount
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              <div className="accounting-services-list">
                {/* rent Row */}
                <div className="accounting-service-item">
                  <div className="accounting-service-info">
                    <div className="accounting-service-checkbox">
                      <input
                        type="checkbox"
                        id="rent_checkbox"
                        checked={rentChecked}
                        onChange={(e) =>
                          handleCheckboxChange("rent", e.target.checked)
                        }
                        style={{ marginRight: "8px", marginTop: "0" }}
                      />
                      <label
                        htmlFor="rent_amount"
                        className="accounting-service-label"
                      >
                        <span
                          className="accounting-service-name"
                          style={{ width: "140px" }}
                        >
                          {capitalizeWords("rent")}
                        </span>
                      </label>
                    </div>
                  </div>

                  <div className="accounting-service-amount">
                    <span
                      className="accounting-amount-due "
                      style={{ width: "60px" }}
                    >
                      {/* ${selectedDriver?.booking_data?.due_rent || 0} */}$
                      {bookingType == "1"
                        ? selectedDriver?.booking_data?.due_rent ?? 0
                        : selectedDriver?.old_booking_data?.due_rent ?? 0}
                    </span>
                  </div>

                  <div className="accounting-service-amount">
                    <span
                      className="accounting-amount-due"
                      style={{ width: "60px" }}
                    >
                      {/* ${selectedDriver?.booking_data?.paid_rent || 0} */}$
                      {bookingType == "1"
                        ? selectedDriver?.booking_data?.paid_rent ?? 0
                        : selectedDriver?.old_booking_data?.paid_rent ?? 0}
                    </span>
                  </div>

                  <div className="accounting-service-amount">
                    <select
                      id="rent"
                      name="rent"
                      className="accounting-amount-input"
                      placeholder="Amount"
                      value={rentSettleto}
                      disabled={!rentChecked}
                      onChange={(e) => {
                        setrentSettleto(e.target.value);
                        setrent(0);
                      }}
                      style={{ width: "102px" }}
                    >
                      <option value="" disabled hidden>
                        Settle to
                      </option>
                      <option value="deposit">deposit</option>
                      <option value="tolls">tolls</option>
                      <option value="damage">damage</option>
                      <option value="ticket">ticket</option>
                      <option value="other">other Charges</option>
                    </select>
                  </div>

                  <div className="accounting-service-amount">
                    <span
                      className="accounting-amount-due"
                      style={{ width: "100px" }}
                    >
                      {(() => {
                        switch (rentSettleto) {
                          case "rent":
                            return `$${
                              // selectedDriver?.booking_data?.due_rent || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_rent
                                : selectedDriver?.old_booking_data?.due_rent ||
                                  0
                            }`;
                          case "deposit":
                            return `$${
                              // selectedDriver?.booking_data?.due_deposit || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_deposit
                                : selectedDriver?.old_booking_data
                                    ?.due_deposit || 0
                            }`;
                          case "tolls":
                            return `$${
                              // selectedDriver?.booking_data?.due_tolls || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_tolls
                                : selectedDriver?.old_booking_data?.due_tolls ||
                                  0
                            }`;
                          case "damage":
                            return `$${
                              // selectedDriver?.booking_data?.due_damage || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_damage
                                : selectedDriver?.old_booking_data
                                    ?.due_damage || 0
                            }`;
                          case "ticket":
                            return `$${
                              // selectedDriver?.booking_data?.due_ticket || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_ticket
                                : selectedDriver?.old_booking_data
                                    ?.due_ticket || 0
                            }`;
                          case "other":
                            return `$${
                              // selectedDriver?.booking_data?.due_other_charges || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data
                                    ?.due_other_charges
                                : selectedDriver?.old_booking_data
                                    ?.due_other_charges || 0
                            }`;
                          default:
                            return "$0";
                        }
                      })()}
                    </span>
                  </div>

                  <div className="accounting-service-amount">
                    <input
                      style={{ width: "102px" }}
                      type="number"
                      id="rent"
                      name="rent"
                      className="accounting-amount-input"
                      placeholder="Amount"
                      value={rent}
                      disabled={!rentChecked}
                      onChange={(e) => {
                        const newValue = e.target.value;

                        // If input is empty or not a number, just update
                        if (newValue === "" || isNaN(Number(newValue))) {
                          setrent(newValue);
                          return;
                        }

                        const enteredRent = Number(newValue);
                        const totalRent = Number(
                          (() => {
                            switch (rentSettleto) {
                              case "rent":
                                return (
                                  // selectedDriver?.booking_data?.due_rent || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_rent
                                    : selectedDriver?.old_booking_data
                                        ?.due_rent || 0
                                );
                              case "deposit":
                                return (
                                  // selectedDriver?.booking_data?.due_deposit || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_deposit
                                    : selectedDriver?.old_booking_data
                                        ?.due_deposit || 0
                                );
                              case "tolls":
                                return (
                                  // selectedDriver?.booking_data?.due_tolls || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_tolls
                                    : selectedDriver?.old_booking_data
                                        ?.due_tolls || 0
                                );
                              case "damage":
                                return (
                                  // selectedDriver?.booking_data?.due_damage || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_damage
                                    : selectedDriver?.old_booking_data
                                        ?.due_damage || 0
                                );
                              case "ticket":
                                return (
                                  // selectedDriver?.booking_data?.due_ticket || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_ticket
                                    : selectedDriver?.old_booking_data
                                        ?.due_ticket || 0
                                );
                              case "other":
                                return (
                                  // selectedDriver?.booking_data?.due_other_charges || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data
                                        ?.due_other_charges
                                    : selectedDriver?.old_booking_data
                                        ?.due_other_charges || 0
                                );
                              default:
                                return 0;
                            }
                          })()
                        );

                        // Only update state if value is valid
                        if (enteredRent < 0) {
                          alert("rent cannot be less than zero.");
                        } else if (enteredRent <= totalRent) {
                          setrent(newValue);
                        } else {
                          // For invalid values, show alert but don't update state
                          e.preventDefault(); // Prevent default behavior
                          alert(
                            `Entered tolls cannot be more than due amount ($${totalRent})`
                          );
                          // Keep the previous value by not calling setRent
                        }
                      }}
                    />
                  </div>
                </div>

                {/* Tolls Row */}
                <div className="accounting-service-item">
                  <div className="accounting-service-info">
                    <div className="accounting-service-checkbox">
                      <input
                        type="checkbox"
                        id="tolls_checkbox"
                        checked={tollsChecked}
                        onChange={(e) =>
                          handleCheckboxChange("tolls", e.target.checked)
                        }
                        style={{ marginRight: "8px", marginTop: "0" }}
                      />
                      <label
                        htmlFor="tolls_amount"
                        className="accounting-service-label"
                      >
                        <span
                          className="accounting-service-name"
                          style={{ width: "140px" }}
                        >
                          {capitalizeWords("Tolls")}
                        </span>
                      </label>
                    </div>
                  </div>

                  <div className="accounting-service-amount">
                    <span
                      className="accounting-amount-due"
                      style={{ width: "60px" }}
                    >
                      {/* ${selectedDriver?.booking_data?.due_tolls || 0} */}$
                      {bookingType == "1"
                        ? selectedDriver?.booking_data?.due_tolls ?? 0
                        : selectedDriver?.old_booking_data?.due_tolls ?? 0}
                    </span>
                  </div>
                  <div className="accounting-service-amount">
                    <span
                      className="accounting-amount-due"
                      style={{ width: "60px" }}
                    >
                      {/* ${selectedDriver?.booking_data?.paid_tolls || 0} */}$
                      {bookingType == "1"
                        ? selectedDriver?.booking_data?.paid_tolls ?? 0
                        : selectedDriver?.old_booking_data?.paid_tolls ?? 0}
                    </span>
                  </div>

                  <div className="accounting-service-amount">
                    <select
                      id="rent"
                      name="rent"
                      className="accounting-amount-input"
                      placeholder="Amount"
                      value={tollsSettleto}
                      disabled={!tollsChecked}
                      onChange={(e) => {
                        settollsSettleto(e.target.value);
                        settolls(0);
                      }}
                      style={{ width: "102px" }}
                    >
                      <option value="" disabled hidden>
                        Settle to
                      </option>
                      <option value="deposit">deposit</option>
                      <option value="rent">rent</option>
                      <option value="damage">damage</option>
                      <option value="ticket">ticket</option>
                      <option value="other">other Charges</option>
                    </select>
                  </div>

                  <div className="accounting-service-amount">
                    <span
                      className="accounting-amount-due"
                      style={{ width: "100px" }}
                    >
                      {(() => {
                        switch (tollsSettleto) {
                          case "rent":
                            return `$${
                              // selectedDriver?.booking_data?.due_rent || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_rent
                                : selectedDriver?.old_booking_data?.due_rent ||
                                  0
                            }`;
                          case "deposit":
                            return `$${
                              // selectedDriver?.booking_data?.due_deposit || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_deposit
                                : selectedDriver?.old_booking_data
                                    ?.due_deposit || 0
                            }`;
                          case "tolls":
                            return `$${
                              // selectedDriver?.booking_data?.due_tolls || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_tolls
                                : selectedDriver?.old_booking_data?.due_tolls ||
                                  0
                            }`;
                          case "damage":
                            return `$${
                              // selectedDriver?.booking_data?.due_damage || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_damage
                                : selectedDriver?.old_booking_data
                                    ?.due_damage || 0
                            }`;
                          case "ticket":
                            return `$${
                              // selectedDriver?.booking_data?.due_ticket || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_ticket
                                : selectedDriver?.old_booking_data
                                    ?.due_ticket || 0
                            }`;
                          case "other":
                            return `$${
                              // selectedDriver?.booking_data?.due_other_charges || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data
                                    ?.due_other_charges
                                : selectedDriver?.old_booking_data
                                    ?.due_other_charges || 0
                            }`;
                          default:
                            return "$0";
                        }
                      })()}
                    </span>
                  </div>

                  <div className="accounting-service-amount">
                    <input
                      type="number"
                      id="tolls"
                      name="tolls"
                      className="accounting-amount-input"
                      placeholder="Amount"
                      value={tolls}
                      disabled={!tollsChecked}
                      style={{ width: "102px" }}
                      onChange={(e) => {
                        const newValue = e.target.value;

                        // If input is empty or not a number, just update
                        if (newValue === "" || isNaN(Number(newValue))) {
                          settolls(newValue);
                          return;
                        }

                        const enteredTolls = Number(newValue);
                        const totalTolls = Number(
                          (() => {
                            switch (tollsSettleto) {
                              case "rent":
                                return (
                                  // selectedDriver?.booking_data?.due_rent || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_rent
                                    : selectedDriver?.old_booking_data
                                        ?.due_rent || 0
                                );
                              case "deposit":
                                return (
                                  // selectedDriver?.booking_data?.due_deposit || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_deposit
                                    : selectedDriver?.old_booking_data
                                        ?.due_deposit || 0
                                );
                              case "tolls":
                                return (
                                  // selectedDriver?.booking_data?.due_tolls || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_tolls
                                    : selectedDriver?.old_booking_data
                                        ?.due_tolls || 0
                                );
                              case "damage":
                                return (
                                  // selectedDriver?.booking_data?.due_damage || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_damage
                                    : selectedDriver?.old_booking_data
                                        ?.due_damage || 0
                                );
                              case "ticket":
                                return (
                                  // selectedDriver?.booking_data?.due_ticket || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_ticket
                                    : selectedDriver?.old_booking_data
                                        ?.due_ticket || 0
                                );
                              case "other":
                                return (
                                  // selectedDriver?.booking_data?.due_other_charges || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data
                                        ?.due_other_charges
                                    : selectedDriver?.old_booking_data
                                        ?.due_other_charges || 0
                                );
                              default:
                                return 0;
                            }
                          })()
                        );

                        // Only update state if value is valid
                        if (enteredTolls < 0) {
                          e.preventDefault();
                          alert("tolls amount cannot be negative.");
                        } else if (enteredTolls <= totalTolls) {
                          settolls(newValue);
                        } else {
                          // For invalid values, show alert but don't update state
                          e.preventDefault(); // Prevent default behavior
                          alert(
                            `Entered tolls cannot be more than due amount ($${totalTolls})`
                          );
                          // Keep the previous value by not calling setTolls
                        }
                      }}
                    />
                  </div>
                </div>

                {/* damage Row */}
                <div className="accounting-service-item">
                  <div className="accounting-service-info">
                    <div className="accounting-service-checkbox">
                      <input
                        type="checkbox"
                        id="damage_checkbox"
                        checked={damageChecked}
                        onChange={(e) =>
                          handleCheckboxChange("damage", e.target.checked)
                        }
                        style={{ marginRight: "8px", marginTop: "0" }}
                      />
                      <label
                        htmlFor="damage"
                        className="accounting-service-label"
                      >
                        <span
                          className="accounting-service-name"
                          style={{ width: "140px" }}
                        >
                          {capitalizeWords("damage")}
                        </span>
                      </label>
                    </div>
                  </div>

                  <div className="accounting-service-amount">
                    <span
                      className="accounting-amount-due"
                      style={{ width: "60px" }}
                    >
                      {/* ${selectedDriver?.booking_data?.due_damage || 0} */}$
                      {bookingType == "1"
                        ? selectedDriver?.booking_data?.due_damage ?? 0
                        : selectedDriver?.old_booking_data?.due_damage ?? 0}
                    </span>
                  </div>

                  <div className="accounting-service-amount">
                    <span
                      className="accounting-amount-due"
                      style={{ width: "60px" }}
                    >
                      {/* ${selectedDriver?.booking_data?.paid_damage || 0} */}$
                      {bookingType == "1"
                        ? selectedDriver?.booking_data?.paid_damage ?? 0
                        : selectedDriver?.old_booking_data?.paid_damage ?? 0}
                    </span>
                  </div>

                  <div className="accounting-service-amount">
                    <select
                      id="rent"
                      name="rent"
                      className="accounting-amount-input"
                      placeholder="Amount"
                      value={damageSettleto}
                      disabled={!damageChecked}
                      onChange={(e) => {
                        setdamageSettleto(e.target.value);
                        setdamage(0);
                      }}
                      style={{ width: "102px" }}
                    >
                      <option value="" disabled hidden>
                        Settle to
                      </option>
                      <option value="deposit">deposit</option>
                      <option value="rent">rent</option>
                      <option value="tolls">tolls</option>
                      <option value="ticket">ticket</option>
                      <option value="other">other Charges</option>
                    </select>
                  </div>

                  <div className="accounting-service-amount">
                    <span
                      className="accounting-amount-due"
                      style={{ width: "100px" }}
                    >
                      {(() => {
                        switch (damageSettleto) {
                          case "rent":
                            return `$${
                              // selectedDriver?.booking_data?.due_rent || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_rent
                                : selectedDriver?.old_booking_data?.due_rent ||
                                  0
                            }`;
                          case "deposit":
                            return `$${
                              // selectedDriver?.booking_data?.due_deposit || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_deposit
                                : selectedDriver?.old_booking_data
                                    ?.due_deposit || 0
                            }`;
                          case "tolls":
                            return `$${
                              // selectedDriver?.booking_data?.due_tolls || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_tolls
                                : selectedDriver?.old_booking_data?.due_tolls ||
                                  0
                            }`;
                          case "damage":
                            return `$${
                              // selectedDriver?.booking_data?.due_damage || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_damage
                                : selectedDriver?.old_booking_data
                                    ?.due_damage || 0
                            }`;
                          case "ticket":
                            return `$${
                              // selectedDriver?.booking_data?.due_ticket || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_ticket
                                : selectedDriver?.old_booking_data
                                    ?.due_ticket || 0
                            }`;
                          case "other":
                            return `$${
                              // selectedDriver?.booking_data?.due_other_charges || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data
                                    ?.due_other_charges
                                : selectedDriver?.old_booking_data
                                    ?.due_other_charges || 0
                            }`;
                          default:
                            return "$0";
                        }
                      })()}
                    </span>
                  </div>

                  <div className="accounting-service-amount">
                    <input
                      style={{ width: "102px" }}
                      type="number"
                      id="damage"
                      name="damage"
                      className="accounting-amount-input"
                      placeholder="Amount"
                      value={damage}
                      disabled={!damageChecked}
                      onChange={(e) => {
                        const newValue = e.target.value;

                        // If input is empty or not a number, just update
                        if (newValue === "" || isNaN(Number(newValue))) {
                          setdamage(newValue);
                          return;
                        }

                        const enteredDamage = Number(newValue);
                        const totalDamage = Number(
                          (() => {
                            switch (damageSettleto) {
                              case "rent":
                                return (
                                  // selectedDriver?.booking_data?.due_rent || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_rent
                                    : selectedDriver?.old_booking_data
                                        ?.due_rent || 0
                                );
                              case "deposit":
                                return (
                                  // selectedDriver?.booking_data?.due_deposit || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_deposit
                                    : selectedDriver?.old_booking_data
                                        ?.due_deposit || 0
                                );
                              case "tolls":
                                return (
                                  // selectedDriver?.booking_data?.due_tolls || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_tolls
                                    : selectedDriver?.old_booking_data
                                        ?.due_tolls || 0
                                );
                              case "damage":
                                return (
                                  // selectedDriver?.booking_data?.due_damage || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_damage
                                    : selectedDriver?.old_booking_data
                                        ?.due_damage || 0
                                );
                              case "ticket":
                                return (
                                  // selectedDriver?.booking_data?.due_ticket || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_ticket
                                    : selectedDriver?.old_booking_data
                                        ?.due_ticket || 0
                                );
                              case "other":
                                return (
                                  // selectedDriver?.booking_data?.due_other_charges || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data
                                        ?.due_other_charges
                                    : selectedDriver?.old_booking_data
                                        ?.due_other_charges || 0
                                );
                              default:
                                return 0;
                            }
                          })()
                        );

                        // Only update state if value is valid
                        if (enteredDamage < 0) {
                          e.preventDefault();
                          alert("damage amount cannot be negative.");
                        } else if (enteredDamage <= totalDamage) {
                          setdamage(newValue);
                        } else {
                          // For invalid values, show alert but don't update state
                          e.preventDefault(); // Prevent default behavior
                          alert(
                            `Entered damage fee cannot be more than due amount ($${totalDamage})`
                          );
                          // Keep the previous value by not calling setDamage
                        }
                      }}
                    />
                  </div>
                </div>

                <div className="accounting-service-item">
                  <div className="accounting-service-info">
                    <div className="accounting-service-checkbox">
                      <input
                        type="checkbox"
                        id="damage_checkbox"
                        checked={ticketChecked}
                        onChange={(e) =>
                          handleCheckboxChange("ticket", e.target.checked)
                        }
                        style={{ marginRight: "8px", marginTop: "0" }}
                      />
                      <label
                        htmlFor="tickets"
                        className="accounting-service-label"
                      >
                        <span
                          className="accounting-service-name"
                          style={{ width: "140px" }}
                        >
                          {capitalizeWords("ticket")}
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="accounting-service-amount">
                    <span
                      className="accounting-amount-due"
                      style={{ width: "60px" }}
                    >
                      {/* ${selectedDriver?.booking_data?.due_ticket || 0} */}$
                      {bookingType == "1"
                        ? selectedDriver?.booking_data?.due_ticket ?? 0
                        : selectedDriver?.old_booking_data?.due_ticket ?? 0}
                    </span>
                  </div>
                  <div className="accounting-service-amount">
                    <span
                      className="accounting-amount-due"
                      style={{ width: "60px" }}
                    >
                      {/* ${selectedDriver?.booking_data?.paid_ticket || 0} */}$
                      {bookingType == "1"
                        ? selectedDriver?.booking_data?.paid_ticket ?? 0
                        : selectedDriver?.old_booking_data?.paid_ticket ?? 0}
                    </span>
                  </div>

                  <div className="accounting-service-amount">
                    <select
                      id="rent"
                      name="rent"
                      className="accounting-amount-input"
                      placeholder="Amount"
                      value={ticketSettleto}
                      disabled={!ticketChecked}
                      onChange={(e) => {
                        setticketSettleto(e.target.value);
                        setticket(0);
                      }}
                      style={{ width: "102px" }}
                    >
                      <option value="" disabled hidden>
                        Settle to
                      </option>
                      <option value="deposit">deposit</option>
                      <option value="rent">rent</option>
                      <option value="tolls">tolls</option>
                      <option value="damage">damage</option>
                      <option value="other">other Charges</option>
                    </select>
                  </div>

                  <div className="accounting-service-amount">
                    <span
                      className="accounting-amount-due"
                      style={{ width: "100px" }}
                    >
                      {(() => {
                        switch (ticketSettleto) {
                          case "rent":
                            return `$${
                              // selectedDriver?.booking_data?.due_rent || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_rent
                                : selectedDriver?.old_booking_data?.due_rent ||
                                  0
                            }`;
                          case "deposit":
                            return `$${
                              // selectedDriver?.booking_data?.due_deposit || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_deposit
                                : selectedDriver?.old_booking_data
                                    ?.due_deposit || 0
                            }`;
                          case "tolls":
                            return `$${
                              // selectedDriver?.booking_data?.due_tolls || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_tolls
                                : selectedDriver?.old_booking_data?.due_tolls ||
                                  0
                            }`;
                          case "damage":
                            return `$${
                              // selectedDriver?.booking_data?.due_damage || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_damage
                                : selectedDriver?.old_booking_data
                                    ?.due_damage || 0
                            }`;
                          case "ticket":
                            return `$${
                              // selectedDriver?.booking_data?.due_ticket || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_ticket
                                : selectedDriver?.old_booking_data
                                    ?.due_ticket || 0
                            }`;
                          case "other":
                            return `$${
                              // selectedDriver?.booking_data?.due_other_charges || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data
                                    ?.due_other_charges
                                : selectedDriver?.old_booking_data
                                    ?.due_other_charges || 0
                            }`;
                          default:
                            return "$0";
                        }
                      })()}
                    </span>
                  </div>

                  <div className="accounting-service-amount">
                    {/* <span className="accounting-amount-due">${selectedDriver?.booking_data?.due_ticket || 0}</span> */}
                    <input
                      style={{ width: "102px" }}
                      type="number"
                      id="tickets"
                      name="tickets"
                      className="accounting-amount-input"
                      placeholder="Amount"
                      value={ticket} // Changed from defaultValue to value for controlled input
                      disabled={!ticketChecked}
                      onChange={(e) => {
                        const newValue = e.target.value;

                        // If input is empty or not a number, just update
                        if (newValue === "" || isNaN(Number(newValue))) {
                          setticket(newValue);
                          return;
                        }

                        const enteredTicket = Number(newValue);
                        const totalTickets = Number(
                          (() => {
                            switch (ticketSettleto) {
                              case "rent":
                                return (
                                  // selectedDriver?.booking_data?.due_rent || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_rent
                                    : selectedDriver?.old_booking_data
                                        ?.due_rent || 0
                                );
                              case "deposit":
                                return (
                                  // selectedDriver?.booking_data?.due_deposit || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_deposit
                                    : selectedDriver?.old_booking_data
                                        ?.due_deposit || 0
                                );
                              case "tolls":
                                return (
                                  // selectedDriver?.booking_data?.due_tolls || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_tolls
                                    : selectedDriver?.old_booking_data
                                        ?.due_tolls || 0
                                );
                              case "damage":
                                return (
                                  // selectedDriver?.booking_data?.due_damage || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_damage
                                    : selectedDriver?.old_booking_data
                                        ?.due_damage || 0
                                );
                              case "ticket":
                                return (
                                  // selectedDriver?.booking_data?.due_ticket || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_ticket
                                    : selectedDriver?.old_booking_data
                                        ?.due_ticket || 0
                                );
                              case "other":
                                return (
                                  // selectedDriver?.booking_data?.due_other_charges || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data
                                        ?.due_other_charges
                                    : selectedDriver?.old_booking_data
                                        ?.due_other_charges || 0
                                );
                              default:
                                return 0;
                            }
                          })()
                        );

                        // Only update state if value is valid
                        if (enteredTicket < 0) {
                          e.preventDefault();
                          alert("Ticket amount cannot be negative.");
                        } else if (enteredTicket <= totalTickets) {
                          setticket(newValue);
                        } else {
                          // For invalid values, show alert but don't update state
                          e.preventDefault(); // Prevent default behavior
                          alert(
                            `Entered ticket amount cannot be more than due amount ($${totalTickets})`
                          );
                          // Keep the previous value by not calling setTicket
                        }
                      }}
                    />
                  </div>
                </div>

                <div className="accounting-service-item" hidden>
                  <div className="accounting-service-info">
                    <div className="accounting-service-checkbox">
                      <label
                        htmlFor="latefees"
                        className="accounting-service-label"
                      >
                        <span
                          className="accounting-service-name"
                          style={{ width: "140px" }}
                        >
                          Late Fees
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="accounting-service-amount">
                    <span className="accounting-amount-due">
                      ${selectedDriver?.booking_data?.due_latefees || 0}
                    </span>
                    <input
                      type="number"
                      id="latefees"
                      name="latefees"
                      className="accounting-amount-input"
                      placeholder="Amount"
                      value={letfees}
                      onChange={(e) => {
                        const newValue = e.target.value;

                        // If input is empty or not a number, just update
                        if (newValue === "" || isNaN(Number(newValue))) {
                          setletfees(newValue);
                          return;
                        }

                        const enteredLateFees = Number(newValue);
                        const totalLateFees = Number(
                          selectedDriver?.booking_data?.due_latefees || 0
                        );

                        // Only update state if value is valid
                        if (enteredLateFees < 0) {
                          e.preventDefault();
                          alert("LateFees amount cannot be negative.");
                        } else if (enteredLateFees <= totalLateFees) {
                          setletfees(newValue);
                        } else {
                          // For invalid values, show alert but don't update state
                          e.preventDefault(); // Prevent default behavior
                          alert(
                            `Entered late fees cannot be more than due amount ($${totalLateFees})`
                          );
                          // Keep the previous value by not calling setLetfees
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="accounting-service-item">
                  <div className="accounting-service-info">
                    <div className="accounting-service-checkbox">
                      <input
                        type="checkbox"
                        id="damage_checkbox"
                        checked={letotherchrChecked}
                        onChange={(e) =>
                          handleCheckboxChange("letotherchr", e.target.checked)
                        }
                        style={{ marginRight: "8px", marginTop: "0" }}
                      />
                      <label
                        htmlFor="latefees"
                        className="accounting-service-label"
                      >
                        <span
                          className="accounting-service-name"
                          style={{ width: "140px" }}
                        >
                          {capitalizeWords("other Charges")}
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="accounting-service-amount">
                    <span
                      className="accounting-amount-due"
                      style={{ width: "60px" }}
                    >
                      {/* ${selectedDriver?.booking_data?.due_other_charges || 0} */}
                      $
                      {bookingType == "1"
                        ? selectedDriver?.booking_data?.due_other_charges ?? 0
                        : selectedDriver?.old_booking_data?.due_other_charges ??
                          0}
                    </span>
                  </div>
                  <div className="accounting-service-amount">
                    <span
                      className="accounting-amount-due"
                      style={{ width: "60px" }}
                    >
                      {/* ${selectedDriver?.booking_data?.paid_other_charges || 0} */}
                      $
                      {bookingType == "1"
                        ? selectedDriver?.booking_data?.paid_other_charges ?? 0
                        : selectedDriver?.old_booking_data
                            ?.paid_other_charges ?? 0}
                    </span>
                  </div>
                  <div className="accounting-service-amount">
                    <select
                      id="rent"
                      name="rent"
                      className="accounting-amount-input"
                      placeholder="Amount"
                      value={letotherchrSettleto}
                      disabled={!letotherchrChecked}
                      onChange={(e) => {
                        setotherchrSettleto(e.target.value);
                        setotherchr(0);
                      }}
                      style={{ width: "102px" }}
                    >
                      <option value="" disabled hidden>
                        Settle to
                      </option>
                      <option value="deposit">deposit</option>
                      <option value="rent">rent</option>
                      <option value="tolls">tolls</option>
                      <option value="damage">damage</option>
                      <option value="ticket">ticket</option>
                    </select>
                  </div>

                  <div className="accounting-service-amount">
                    <span
                      className="accounting-amount-due"
                      style={{ width: "100px" }}
                    >
                      {(() => {
                        switch (letotherchrSettleto) {
                          case "rent":
                            return `$${
                              // selectedDriver?.booking_data?.due_rent || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_rent
                                : selectedDriver?.old_booking_data?.due_rent ||
                                  0
                            }`;
                          case "deposit":
                            return `$${
                              // selectedDriver?.booking_data?.due_deposit || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_deposit
                                : selectedDriver?.old_booking_data
                                    ?.due_deposit || 0
                            }`;
                          case "tolls":
                            return `$${
                              // selectedDriver?.booking_data?.due_tolls || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_tolls
                                : selectedDriver?.old_booking_data?.due_tolls ||
                                  0
                            }`;
                          case "damage":
                            return `$${
                              // selectedDriver?.booking_data?.due_damage || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_damage
                                : selectedDriver?.old_booking_data
                                    ?.due_damage || 0
                            }`;
                          case "ticket":
                            return `$${
                              // selectedDriver?.booking_data?.due_ticket || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data?.due_ticket
                                : selectedDriver?.old_booking_data
                                    ?.due_ticket || 0
                            }`;
                          case "other":
                            return `$${
                              // selectedDriver?.booking_data?.due_other_charges || 0
                              bookingType == "1"
                                ? selectedDriver?.booking_data
                                    ?.due_other_charges
                                : selectedDriver?.old_booking_data
                                    ?.due_other_charges || 0
                            }`;
                          default:
                            return "$0";
                        }
                      })()}
                    </span>
                  </div>

                  <div className="accounting-service-amount">
                    <input
                      style={{ width: "102px" }}
                      type="number"
                      id="otherCharge"
                      name="otherCharge"
                      className="accounting-amount-input"
                      placeholder="Amount"
                      value={letotherchr}
                      disabled={!letotherchrChecked}
                      onChange={(e) => {
                        const newValue = e.target.value;

                        // If input is empty or not a number, just update
                        if (newValue === "" || isNaN(Number(newValue))) {
                          setotherchr(newValue);
                          return;
                        }

                        const enteredother_charges = Number(newValue);
                        const totalother_charges = Number(
                          (() => {
                            switch (letotherchrSettleto) {
                              case "rent":
                                return (
                                  // selectedDriver?.booking_data?.due_rent || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_rent
                                    : selectedDriver?.old_booking_data
                                        ?.due_rent || 0
                                );
                              case "deposit":
                                return (
                                  // selectedDriver?.booking_data?.due_deposit || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_deposit
                                    : selectedDriver?.old_booking_data
                                        ?.due_deposit || 0
                                );
                              case "tolls":
                                return (
                                  // selectedDriver?.booking_data?.due_tolls || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_tolls
                                    : selectedDriver?.old_booking_data
                                        ?.due_tolls || 0
                                );
                              case "damage":
                                return (
                                  // selectedDriver?.booking_data?.due_damage || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_damage
                                    : selectedDriver?.old_booking_data
                                        ?.due_damage || 0
                                );
                              case "ticket":
                                return (
                                  // selectedDriver?.booking_data?.due_ticket || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data?.due_ticket
                                    : selectedDriver?.old_booking_data
                                        ?.due_ticket || 0
                                );
                              case "other":
                                return (
                                  // selectedDriver?.booking_data?.due_other_charges || 0
                                  bookingType == "1"
                                    ? selectedDriver?.booking_data
                                        ?.due_other_charges
                                    : selectedDriver?.old_booking_data
                                        ?.due_other_charges || 0
                                );
                              default:
                                return 0;
                            }
                          })()
                        );

                        // Only update state if value is valid
                        if (enteredother_charges < 0) {
                          e.preventDefault();
                          alert("other charges amount cannot be negative.");
                        } else if (enteredother_charges <= totalother_charges) {
                          setotherchr(newValue);
                        } else {
                          // For invalid values, show alert but don't update state
                          e.preventDefault(); // Prevent default behavior
                          alert(
                            `Entered other Charges cannot be more than due amount ($${totalother_charges})`
                          );
                          // Keep the previous value by not calling setotherchr
                        }
                      }}
                    />
                  </div>
                </div>

                <div
                  className="accounting-service-total py-0 justify-content-end align-items-center gap-4"
                  style={{ height: "60px" }}
                >
                  <div
                    className="d-flex justify-content-end align-items-center"
                    style={{
                      borderRight: "1px solid #d9d9d9",
                      height: "100%",
                      paddingRight: "1.5rem ",
                    }}
                  >
                    <span className="accounting-total-label">Total Amount</span>
                  </div>
                  <div style={{ width: "102px" }}>
                    <span className="accounting-total-amount">$</span>
                    <span className="accounting-total-amount totlamt">
                      {totalamount}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div className="accounting-payment-notes">
            <div className="accounting-notes-field">
              <label htmlFor="payment-notes" className="accounting-label">
                Payment Notes (Optional)
              </label>
              <textarea
                id="payment-notes"
                name="transaction_note"
                rows="3"
                className="accounting-textarea"
                placeholder="Add any notes regarding this payment..."
                onChange={(e) => setnotes(e.target.value)}
              ></textarea>
            </div>

            <div className="accounting-payment-actions">
              <div className="accounting-receipt-option"></div>

              <div className="accounting-form-buttons">
                <button
                  type="button"
                  className="accounting-btn accounting-btn-secondary"
                >
                  Cancel
                </button>
                <button
                  id="save-payment-btn"
                  type="button"
                  className="accounting-btn accounting-btn-primary"
                  onClick={() => {
                    handleSaveChangesdynamic(
                      "createRightsForm",
                      payment_reallocation
                    );
                    handleCreateArray();
                  }}
                >
                  Save Payment
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PaymentHeadsSettlement;
